var _excluded = ["percentage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect, useRef, useState } from 'react';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { useCircleSvg } from './useCircleSvg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CircularProgress = forwardRef((_ref, ref) => {
  var {
    percentage
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var [offset, setOffset] = useState(0);
  var progressAnimation = useRef();
  var {
    circleAttributes,
    strokeDasharray
  } = useCircleSvg(offset);
  var styles = useMultiStyleConfig('CircularProgress', {
    strokeDasharray
  });
  useEffect(() => {
    // set the progress animation
    progressAnimation.current = window.setTimeout(() => {
      setOffset(percentage);
    }, 0);
    return () => {
      clearTimeout(progressAnimation.current);
    };
  }, [percentage]);
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    ref: ref,
    __css: styles['container'],
    "data-component": "CircularProgress"
  }, rest), {}, {
    as: "svg" // ts-ignore is used due to `svg` props issues with `<Box/>`.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    ,
    viewBox: "0 0 100 100",
    children: [/*#__PURE__*/_jsx(Box, _objectSpread({
      as: "circle",
      __css: styles['circle']
    }, circleAttributes)), /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      as: "circle",
      __css: styles['track']
    }, circleAttributes), {}, {
      "data-progress": offset
    }))]
  }));
});
CircularProgress.displayName = 'CircularProgress';
//# sourceMappingURL=CircularProgress.js.map